import { CompositeSpecification } from "../../../utils/Specification";

const USPI_CENTERS = ['LRY', 'F9S', 'A98'];

export class IsUspiCenter extends CompositeSpecification<string>{
    IsSatisfiedBy(centerId: string): boolean {
        return USPI_CENTERS.includes(centerId.toUpperCase());
    }
}
